// extracted by mini-css-extract-plugin
module.exports = {"discussions":"F5i3","header":"F5ap","list":"F5ar","item":"F5at","link":"F5ch","pageLink":"F5zv","commentsLink":"F5kb"};